export const aboutListItems = (t) => [
  t("about_item1"),
  t("about_item2"),
  t("about_item3"),
  t("about_item4"),
  t("about_item5"),
];
